import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { FolderOpenSolidSVG } from '@common_components/svg/folderOpenSolid.svg';

const FolderOpenSolidIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <FolderOpenSolidSVG/>
    </div>
  );
};

export { FolderOpenSolidIcon };
